import * as React from 'react'

import { PostNavigationBanner } from '../../Shared';
import { SPONSORED_SUBSCRIPTION_TYPES, TEACHER_SPONSORED_FREE } from '../components/subscriptions/constants'

function buildAdminContactMailtoForTeks(schoolAdmins, subscriptionType) {
  const subject = "Can we unlock Quill’s TEKS-aligned activities?";

  let toEmail = "";

  if (schoolAdmins?.length === 1) {
    toEmail = schoolAdmins[0].email || "";
  }

  const body = `Hi there,

I'm interested in using Quill's new TEKS-aligned writing and grammar activities with my students. Each grade has a full year of activities aligned to the ELAR TEKS, designed to build STAAR readiness.

These activities are only available through a Quill School or District Premium partnership, which also includes expanded reporting, rostering, and support.

You can see the full list of Premium features here: https://www.quill.org/premium. If you're open to learning more or exploring pricing, Quill's Partnerships Team can reach out if you complete this short form: https://quillorg.salesmate.io/webforms/#/8be9dc8d-0315-44d5-b7a8-dd268fa7726e.

Thanks for considering it!`;

  return `mailto:${toEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

function teacherType(subscriptionType) {
  if (!subscriptionType) {
    return "free Quill teacher"
  } else {
    return "Quill Premium teacher"
  }
}

export const teksPremiumBanner = (schoolAdmins, subscriptionType) => {
  if (SPONSORED_SUBSCRIPTION_TYPES.includes(subscriptionType)) {
    return null
  }
  const bodyText = `You are currently a ${teacherType(subscriptionType)}. Want to give your students TEKS-aligned writing and grammar practice that builds confidence and STAAR-ready skills? Ask your admin to upgrade to Quill Premium for Schools and Districts.`
  return(
    <PostNavigationBanner
      bannerStyle="gold-secondary school-year-updates-card"
      bodyText={<p>{bodyText}</p>}
      buttons={[
        {
          className: 'gold small contained focus-on-light',
          href: buildAdminContactMailtoForTeks(schoolAdmins, subscriptionType),
          text: "Contact Your Admin",
          target: "_blank"
        },
        {
          className: 'gold small outlined focus-on-light',
          href: '/premium',
          text: "Learn More About Premium",
          target: "_blank"
        }
      ]}
      className="teks-premium-banner"
      primaryHeaderText="Unlock all TEKS alignments with Quill Premium for Schools and Districts"
    />
  )
}
